import Utils from "../utils";
import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
  name: "capitalized"
})
export class CapitalizedPipe implements PipeTransform {
  transform(value: string): string {
    return value ? value[0].toUpperCase() + value.substr(1).toLowerCase() : "";
  }
}
